const forbiddenArray = ["fuck", "tmd", "他妈的","小孩","刀","枪","暴","黄","赌","毒","习近平","毛泽东"];
export default forbiddenArray;